export const mergeBorderRadii = (baseRadii, overrideRadii) => {
    const style = overrideRadii.style ?? (overrideRadii.primary === 0 ? 'square' : 'rounded');
    if (style === 'square') {
        return {
            small: 0,
            medium: 0,
            large: 0,
            control: 0,
        };
    }
    return style === 'pill' ? { ...baseRadii, control: 9999 } : baseRadii;
};
//# sourceMappingURL=mergeBorderRadii.js.map